import React, { useState, useContext, useEffect } from 'react';
import { Helper } from 'utils';
import { Api } from 'services';
import { AppActions } from 'store';
import { StateContext, DispatchContext } from 'context';
import './contacto.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapMarkerAlt, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { withRouter } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { Themes } from 'styles';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
// import { ContactoBackground } from 'assets/img';

const Contacto = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useContext(DispatchContext);
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    const [msgEnvioExitoso, setMsgEnvioExitoso] = useState("");
    const [estaEnviando, setEstaEnviando] = useState(false); // <--- NUEVO ESTADO
    const [data, setData] = useState({
        cm_nombre: "",
        cm_telefono: "",
        cm_email: "",
        cm_mensaje: ""
    });
    const [errores, setErrores] = useState({
        cm_nombre: false,
        cm_telefono: false,
        cm_email: false,
        cm_mensaje: false
    });
    const [modelo, setModelo] = useState({
        cm_nombre: "",
        cm_telefono: "",
        cm_email: "",
        cm_mensaje: ""
    });
    useEffect(() => {
        getModelo();
    }, []);

    const getModelo = () => {
        dispatch(AppActions.setLoading(true));
        dispatch(AppActions.setActionsDisabled(true));
        var options = {
            url: Api.route('/contacto_mensaje/modelo'),
            method: 'GET'
        };
        Api.requestAxios(options, response => {
            Helper.log('getModelo response', response);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
            if (response.data.codigo && response.data.codigo !== 200) {
                // enqueueSnackbar(response.data.mensaje, { variant: 'error' });
            } else {
                if (response.data.datos) {
                    setData(response.data.datos);
                    setModelo(response.data.datos);
                }
            }
        }, error => {
            Helper.log('error getModelo', error);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
        });
    }

    const onChangeForm = (event, campo) => {
        setData({
            ...data,
            [campo]: event.target.value
        });
        setErrores({
            ...errores,
            [campo]: false
        });
    }
    const enviar = () => {
        const { cm_nombre, cm_telefono, cm_email, cm_mensaje } = data;
        let todoBien = true;
        let errors = {
            cm_nombre: false,
            cm_telefono: false,
            cm_email: false,
            cm_mensaje: false
        };
        
        // Validación de campos
        if (!cm_nombre || cm_nombre === "") {
            todoBien = false;
            errors.cm_nombre = true;
        }
        if (!cm_telefono || cm_telefono === "") {
            todoBien = false;
            errors.cm_telefono = true;
        }
        if (!cm_email || cm_email === "" || !Helper.validateEmail(cm_email)) {
            todoBien = false;
            errors.cm_email = true;
        }
        if (!cm_mensaje || cm_mensaje === "") {
            todoBien = false;
            errors.cm_mensaje = true;
        }

        setErrores(errors);
        
        if (todoBien) {
            console.log('data', data);
            
            // Establecer estado de envío
            setEstaEnviando(true); // <--- INICIA EL ENVÍO
            setMsgEnvioExitoso(""); // Limpiar mensaje previo

            dispatch(AppActions.setLoading(true));
            dispatch(AppActions.setActionsDisabled(true));
            var options = {
                url: Api.route('/contacto_mensaje/guardar'),
                method: 'POST',
                data: data
            };
            Api.request(options, response => {
                Helper.log('enviarEmailContacto response', response);
                
                // Finalizar estado de envío
                setEstaEnviando(false); // <--- FINALIZA EL ENVÍO

                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
                
                if (response.codigo && response.codigo !== 200) {
                    enqueueSnackbar(response.mensaje, { variant: 'error' });
                    setMsgEnvioExitoso("Ocurrió un error al enviar tu mensaje."); // Mensaje de error
                } else if (response.codigo && response.codigo === 200) {
                    setData(modelo);
                    setMsgEnvioExitoso("¡Mensaje Enviado! Hemos recibido tu mensaje, gracias por comunicarte con nosotros."); // Mensaje de éxito
                    setTimeout(() => {
                        setMsgEnvioExitoso("");
                    }, 6000);
                }
            }, error => {
                Helper.log('error enviarEmailContacto', error);
                
                // Finalizar estado de envío
                setEstaEnviando(false); // <--- FINALIZA EL ENVÍO

                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
                enqueueSnackbar('Ocurrió un error al comunicarse con el servidor.', { variant: 'error' });
                setMsgEnvioExitoso("Ocurrió un error al enviar tu mensaje."); // Mensaje de error
            });
        }
    }

    return (
        <>
            <div id="contacto" className="bs-bbox" style={{ backgroundColor: Themes[indexTema].D4 }}>
                <div className="w3-content">
                    <div className="w3-block w3-padding-large w3-center bs-bbox">
                        <h1 className="w3-text-white font-lato-bold">Contacto</h1>
                    </div>
                    <div className="w3-row font-lato-bold">
                        <div className="w3-col l6">
                            <form className="w3-block">
                                <div className="w3-row">
                                    <div className="w3-col l6 bs-bbox w3-padding">
                                        <label>Nombre</label>
                                        <input placeholder="Ingrese su Nombre"  type="text" className={`w3-padding w3-transparent w3-round-large w3-large ${errores.cm_nombre ? 'input-error' : ''}`}
                                            value={data.cm_nombre}
                                            onChange={event => onChangeForm(event, 'cm_nombre')}></input>
                                            {errores.cm_nombre && <p className="w3-text-red w3-small">El nombre es obligatorio.</p>}
                                    </div>
                                    <div className="w3-col l6 bs-bbox w3-padding">
                                        <label>Teléfono</label>
                                        <input placeholder="Ingrese su teléfono" type="text" className={`w3-padding w3-transparent w3-round-large w3-large ${errores.cm_telefono ? 'input-error' : ''}`}
                                            value={data.cm_telefono}
                                            onChange={event => onChangeForm(event, 'cm_telefono')}></input>
                                            {errores.cm_telefono && <p className="w3-text-red w3-small">El teléfono es obligatorio.</p>}
                                    </div>
                                </div>
                                <div className="w3-row">
                                    <div className="w3-col l12 bs-bbox w3-padding">
                                        <label>Email</label>
                                        <input placeholder="Ingrese su Correo" type="email" className={`w3-padding w3-transparent w3-round-large w3-large ${errores.cm_email ? 'input-error' : ''}`}
                                            value={data.cm_email}
                                            onChange={event => onChangeForm(event, 'cm_email')}></input>
                                            {errores.cm_email && <p className="w3-text-red w3-small">Ingrese un email válido.</p>}
                                    </div>
                                </div>
                                <div className="w3-row">
                                    <div className="w3-col l12 bs-bbox w3-padding">
                                        <label>Mensaje</label><br />
                                        <textarea placeholder="Escriba un mensaje" rows="8" className={`w3-padding w3-transparent w3-round-large w3-large ${errores.cm_mensaje ? 'input-error' : ''}`}
                                            value={data.cm_mensaje}
                                            onChange={event => onChangeForm(event, 'cm_mensaje')} maxLength="250"></textarea>
                                            <div style={{textAlign: "end", color: "white" }}>{data.cm_mensaje.length}/250</div>
                                            {errores.cm_mensaje && <p className="w3-text-red w3-small">El mensaje es obligatorio.</p>}
                                    </div>
                                </div>
                                <div className="w3-row">
                                    <div className="w3-col l12 bs-bbox w3-padding w3-center">
                                        {/* <button className="w3-btn w3-xlarge" type="button" onClick={enviar}>Enviar</button> */}
                                        <button 
                                            className="w3-btn w3-xlarge" 
                                            type="button" 
                                            onClick={enviar} 
                                            disabled={estaEnviando} // <--- DESHABILITAR MIENTRAS SE ENVÍA
                                        >
                                            {estaEnviando ? 'Enviando...' : 'Enviar'} {/* <--- CAMBIAR TEXTO */}
                                        </button>
                                        {msgEnvioExitoso ? <p className="w3-text-white">{msgEnvioExitoso}</p> : null}
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="w3-col l6 bs-bbox links-container" style={{ paddingTop: '10px', paddingLeft: '40px', paddingRight: '16px' }}>
                            <div className="w3-row">
                                <div className="w3-col" style={{ width: '30px' }}>
                                    <FontAwesomeIcon icon={faMapMarkerAlt} color="#fff" size="1x" />
                                </div>
                                <div className="w3-rest">
                                    <a href="https://goo.gl/maps/DWLgG3wSCee2HQYe8" target="_blank" rel="noreferrer">Casa Central: Brasil 1050 e/ Tte. Fariña y Rca. de Colombia, Paraguay</a>
                                </div>
                            </div><br />
                            <div className="w3-row">
                                <div className="w3-col" style={{ width: '30px' }}>
                                    <FontAwesomeIcon icon={faPhoneAlt} color="#fff" size="1x" />
                                </div>
                                <div className="w3-rest">
                                    <a href="tel:+59521210363" rel="noreferrer">+595 (021) 210 363</a>
                                </div>
                            </div><br />
                            { !props.autorizacion ? <>
                                 <div className="w3-row">
                                    <div className="w3-col" style={{ width: '30px' }}>
                                        <FontAwesomeIcon icon={faWhatsapp} color="#fff" size="1x" />
                                    </div>
                                  <div className="w3-rest">
                                        <a href="https://wa.me/595986229400" rel="noreferrer">+595 986 229 400</a>
                                    </div> 
                                </div><br /> 
                            </> : null } 
                            <div className="w3-row">
                                <div className="w3-col" style={{ width: '30px' }}>
                                    <FontAwesomeIcon icon={faEnvelope} color="#fff" size="1x" />
                                </div>
                                <div className="w3-rest">
                                    <a href="mailto:ventas@servitravel.com.py" rel="noreferrer">ventas@servitravel.com.py</a>
                                </div>
                            </div><br />
                            <iframe title="mapa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.2928825111594!2d-57.631261684456334!3d-25.2943620838511!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x945da7e6af54f8eb%3A0x3f9f3d93a38eeb05!2sServi%20Travel%20S.A.!5e0!3m2!1ses!2spy!4v1635537205885!5m2!1ses!2spy"
                                width="100%"
                                height="255"
                                style={{ border: 0, borderRadius: '10px' }}
                                allowFullScreen=""
                                loading="lazy"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default withRouter(Contacto);